export const ShippingDocketTemplate = {
  id: 2,
  name: "Bordereau d’expédition Classique",
  description: "Template standard avec logo, QR et mentions légales.",
  variables: [
    { key: "companyHigherAuthority", label: "Autorité Supérieure", default: "MINPOSTEL" },
    { key: "companyName", label: "Nom de l’entreprise", default: "JAHAGAL VOYAGES" },
    { key: "companyInfoLine1", label: "Ligne 1 Info", default: "TRANSPORT INTER-URBAIN" },
    { key: "companyInfoLine2", label: "Ligne 2 Info", default: "Tél : +237xxxxxxxxx / +237xxxxxxxxx" },
    { key: "companyInfoLine3", label: "Ligne 3 Info", default: "B.P : 00 CM" },
    { key: "urll", label: "Lien QR Code", default: "https://my.jahagal.com/qr" },
  ],
  is_default: true,
  type: "docket-shipping",
  reference: "shipping-docket-1",
};
